import angular from 'angular';

import './color-palette.style.sass';
import template from './color-palette.tpl.pug';

class ColorPaletteController {
    $onInit() {
        this.page = 0;
    }

    $onChanges(changeObject) {
        if (changeObject.colors && changeObject.colors.currentValue) {
            let colors = changeObject.colors.currentValue || [];

            this.colors = colors.map((color) => angular.merge({}, color));
        }

        this.updateSelectedColor(this.colors || [], this.hex);
    }

    updateSelectedColor(colors, hex) {
        colors.forEach((color) => {
            color.selected = color.hex === hex;
        });
    }

    get pageSize() {
        return (this.columns || 7) * (this.rows || 4);
    }

    get pageCount() {
        if (!this.colors || this.colors.length === 0) {
            return 1;
        }

        return Math.ceil(this.colors.length / this.pageSize);
    }

    get visibleColors() {
        const size = this.pageSize;
        const start = this.page * size;
        return (this.colors || []).slice(start, start + size);
    }

    goPreviousPage() {
        if (this.page > 0) {
            this.page -= 1;
        }
    }

    goNextPage() {
        if (this.page < this.pageCount - 1) {
            this.page += 1;
        }
    }

    select(color) {
        if (!this.disabled) {
            this.$ctrl.$setViewValue(color.hex);

            return this.onChange({
                color: color.hex
            });
        }
    }
}

export default {
    selector: 'dbAColorPalette',
    template: template(),
    controller: ColorPaletteController,
    require: {
        $ctrl: 'ngModel'
    },
    bindings: {
        hex: '<ngModel',
        colors: '<',
        disabled: '<ngDisabled',
        rows: '<',
        columns: '<',
        onChange: '&'
    }
};



// WEBPACK FOOTER //
// ./src/application/component/modals/component/category-edit-modal/component/color-palette/color-palette.cmpt.js